export class Promotion {
    image: string;
    name: string;
    description: string;
}
